import controller from './payment-orders.controller';
import template from './payment-orders.view.html';

let PaymentOrdersComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default PaymentOrdersComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/payments-advances/payment-orders/payment-orders.component.js
 **/